import React, { useEffect } from "react";
import useExecutiveApi from "src/scenes/overview/use-executive-api";
import { useSearchParams } from "react-router-dom";

export const OverviewContext = React.createContext();

const OverviewProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [expandedView, setExpandedView] = React.useState(false);
    const [selectedTeam, setSelectedTeam] = React.useState(
        searchParams.get("selectedTeam") || undefined
    );
    const [refresh, setRefresh] = React.useState(false);
    const [aggregationPeriod, setAggregationPeriod] = React.useState("day");
    const [devsOnly, setDevsOnly] = React.useState();

    useEffect(() => {
        if (selectedTeam !== searchParams.get("selectedTeam")) {
            setSearchParams({ selectedTeam });
        }
    }, [selectedTeam]);

    const executiveApi = useExecutiveApi({
        selectedTeam,
        setExpandedView,
        type: "overview",
        refresh,
        devsOnly,
    });
    const executiveTimeseriesApi = useExecutiveApi({
        selectedTeam,
        setExpandedView,
        type: "timeseries",
        refresh,
        aggregationPeriod,
        devsOnly,
    });

    const value = React.useMemo(() => ({
        selectedTeam,
        executiveApi,
        executiveTimeseriesApi,
        setExpandedView,
        setSelectedTeam,
        expandedView,
        setRefresh,
        aggregationPeriod,
        setAggregationPeriod,
        devsOnly,
        setDevsOnly,
        refresh,
    }));
    return <OverviewContext.Provider value={value}>{children}</OverviewContext.Provider>;
};
export default OverviewProvider;
